import { render, staticRenderFns } from "./CarouselControls.vue?vue&type=template&id=44d0e53a&"
import script from "./CarouselControls.vue?vue&type=script&lang=js&"
export * from "./CarouselControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d0e53a')) {
      api.createRecord('44d0e53a', component.options)
    } else {
      api.reload('44d0e53a', component.options)
    }
    module.hot.accept("./CarouselControls.vue?vue&type=template&id=44d0e53a&", function () {
      api.rerender('44d0e53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/CarouselControls.vue"
export default component.exports